/* eslint import/imports-first: 0 */
import './polyfills';
//import designerIcons from './assets/fonts/designer-icons.font';
import React from 'react';
import Promise from 'bluebird';
Promise.config({
    cancellation: true
});
import { render } from 'react-dom';
import AppProvider from './components/AppProvider';

render(<AppProvider />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js